import React from "react";
import ViewLayout from "../layouts/ViewLayout";

const NotFoundPage = () => {
  return <ViewLayout title="Not Found">This page does not exist</ViewLayout>;
};

export default NotFoundPage;
